import { action } from 'mobx';
import { BasePreviewViewStore} from 'core/stores';
import {applicationContext} from 'core/utils';
import { SalesOrderService } from 'application/patient/services';

@applicationContext
class SalesOrderPreviewViewStore extends BasePreviewViewStore {
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.orderId;

        super(rootStore, {
            name: 'order',
            autoInit: true,
            id: id,
            actions: () => {
                const service = new SalesOrderService(rootStore.application.baasic.apiClient);                                
                return {
                    get: async (id) => {
                        const response = await service.get(id);
                        return response.data;
                    }
                }
            }
        });

        this.brightreeBaseUrl = this.rootStore.applicationStore.app.baasic.settings.brightreeBaseUrl;
    }

    @action.bound
    async getResource(id) {
        await super.getResource(id);
    }
}

export default SalesOrderPreviewViewStore;